import { combineReducers } from 'redux';
import ActionTypes from '../constants/ActionTypes';
import createReducer from '../utils/createReducer';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_CATEGORY_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload }),
    [ActionTypes.FETCH_CATEGORY_LIST_SUCCESS]: (state, { payload }) => {
      return Object.assign({}, state, { [payload.url]: payload.categories });
    }
  }
);

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_CATEGORY_SUCCESS]: (state, { type, payload }) =>
      Object.assign({}, state, { [payload.key]: type }),
    [ActionTypes.FETCH_CATEGORY_LIST_SUCCESS]: (state, { type, payload }) =>
      Object.assign({}, state, { [payload.url]: type })
  }
);

export default combineReducers({
  list,
  status
});
